// The design's own tokens (`Hormonal Wellness 1a.dc.html`). They are not the
// app's theme colours — the design's orange is #F26A1F, not the app's
// #FF6414 — so they live here, once, and the view models hand them to the UI
// as plain values.

export const ORANGE = '#F26A1F';

/** Value ramps, light → dark, one colour per bin (see format.bin). */
export const RUST = ['#F6E4DD', '#EBC3B3', '#D99A82', '#BF6F57', '#8E4330'];
export const ORNG = ['#FDEBDD', '#FBD0B0', '#F6A774', '#E97B3A', '#B9460F'];
/** Text colour on each ramp bin. */
export const RAMP_FG = ['#2a1a12', '#2a1a12', '#2a1a12', '#1f1209', '#fff'];
/** Darker ramps for the day detail's big value. */
export const RUST_TEXT = ['#B0715A', '#A05A42', '#8E4632', '#773726', '#5E2617'];
export const ORNG_TEXT = ['#C77436', '#B8602A', '#A9480F', '#8A380C', '#6A2A08'];

export const HATCH = 'repeating-linear-gradient(135deg,#EDE6E0 0 2px,#fff 2px 6px)';
export const DASH = 'repeating-linear-gradient(90deg,#3a3a3a 0 5px,transparent 5px 8px)';
export const hatchOf = (color) => `repeating-linear-gradient(135deg,${color}55 0 3px,#fff 3px 7px)`;

/** Phase lane colours on the Periods calendar. */
export const PHASE_STYLE = {
  Menstrual: { bg: '#B5654A', fg: '#9A4F37', label: 'Menstrual' },
  Follicular: { bg: '#9DB5A0', fg: '#4F6E54', label: 'Follicular' },
  Ovulatory: { bg: '#D9B44A', fg: '#7A6118', label: 'Ovulatory' },
  Luteal: { bg: '#A9A5CC', fg: '#57537F', label: 'Luteal' },
  est: { bg: 'repeating-linear-gradient(90deg,#A9A5CC 0 4px,transparent 4px 7px)', fg: '#57537F', label: 'Luteal · estimated' },
};

export const PHASES = ['Menstrual', 'Follicular', 'Ovulatory', 'Luteal'];

export const METRICS = [
  { id: 'periods', name: 'Periods', color: '#D49073' },
  { id: 'pms', name: 'PMS', color: '#B5654A' },
  { id: 'energy', name: 'Energy', color: ORANGE },
  { id: 'cravings', name: 'Cravings', color: ORANGE },
];
